(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["nav-link"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    Alpine.data('dropdown', () => ({
      open: false,
      toggle() {
        this.open = !this.open;
      },
      init() {
        // Add responsive logic for dropdowns
        const isDesktop = window.matchMedia('(min-width: 768px)').matches;

        // On desktop, we want hover behavior
        if (isDesktop) {
          // Add hover listeners to handle desktop navigation
          this.$el.addEventListener('mouseenter', () => {
            if (window.matchMedia('(min-width: 768px)').matches) {
              this.open = true;
            }
          });

          this.$el.addEventListener('mouseleave', () => {
            if (window.matchMedia('(min-width: 768px)').matches) {
              this.open = false;
            }
          });
        }
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

})();
